<div class="tag body-2">
    <p class="tag__label">{{ title() }}</p>
    <mat-icon svgIcon="ico_close" [ariaLabel]="ariaLabel()" (libAccessibleClick)="closeEvent.emit()" />
</div>
